(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityFieldsDiagram', drvEntityFieldsDiagram);
            
    /**
     * @ngdoc directive
     * @name drvEntityFieldsDiagram
     *
     * @description
     * Display fields for an entity template in a diagram that permits selection.
     */
    function drvEntityFieldsDiagram() {
        return {
            scope: {
                multiSelected: '='
            },
            templateUrl: 'app/entitytemplate/entity-fields-diagram.tmpl.html',
            controller: EntityFieldsDiagramCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                diagramFields: '=',
                fields: '='
            }
        };
    }

    EntityFieldsDiagramCtrl.$inject = ['$scope', 'SystemService'];

    function EntityFieldsDiagramCtrl($scope, SystemService) {
        var drvCtrl = this;
        drvCtrl.graphModel = new joint.dia.Graph();
        drvCtrl.graphMatrix = [];
        drvCtrl.gridHeight = 80;
        drvCtrl.gridWidth = 140;
        drvCtrl.elementHeight = 60;
        drvCtrl.elementWidth = 120;
        drvCtrl.elementColour = 'white';
        drvCtrl.elementHighlightedColour = 'grey';
        drvCtrl.groupManyColour = 'red';
        drvCtrl.groupManyHighlightedColour = 'orange';
        drvCtrl.groupSingleColour = 'aqua';
        drvCtrl.groupSingleHighlightedColour = 'aliceblue';
        // Current path value used when in single select mode
        drvCtrl.singleSelectCurrentPath = '';

        drvCtrl.control = {};
        drvCtrl.control.refreshGraph = refreshGraph;
        drvCtrl.control.updateFields = updateCurrentFields;

        drvCtrl.reloadGraph = reloadGraph;
        drvCtrl.changePath = changePath;
        drvCtrl.addGraphNode = addGraphNode;
        drvCtrl.fieldClicked = fieldClicked;
        drvCtrl.findParent = findParent;
        drvCtrl.selectParent = selectParent;
        drvCtrl.unselectParent = unselectParent;
        drvCtrl.selectChild = selectChild;
        drvCtrl.unselectChild = unselectChild;
        drvCtrl.selectAll = selectAll;
        drvCtrl.unselectAll = unselectAll;
        drvCtrl.showField = showField;
        drvCtrl.generateMatrix = generateMatrix;
        drvCtrl.generateMatrixChild = generateMatrixChild;
        drvCtrl.addMatrixField = addMatrixField;
        drvCtrl.calculateNextRowPosition = calculateNextRowPosition;
        drvCtrl.highlightField = highlightField;
        drvCtrl.dehighlightField = dehighlightField;
        drvCtrl.dehighlightAll = dehighlightAll;
        drvCtrl.calculatePath = calculatePath;
        drvCtrl.updateCurrentFields = updateCurrentFields;

        activate();

        function activate() {
            drvCtrl.diagram = new joint.dia.Paper({
                el: $('#entityFieldsDiagram'),
                gridSize: 1,
                model: drvCtrl.graphModel,
                interactive: false
            });

            $scope.$watch('drvCtrl.diagramFields', function (newVal, oldVal) {
                if (angular.isDefined(drvCtrl.diagramFields) && drvCtrl.diagramFields !== null) {
                    drvCtrl.fields = angular.copy(drvCtrl.diagramFields);
                    drvCtrl.fields.Path = '';
                    refreshGraph();
                }
            });

            $scope.$watch(function () {
                // If the graph element was not visible during the last refresh, we need to try again.
                // We try this on the digest for lack of a better event.
                if (lastRefreshWasNotVisible) {
                    refreshGraph();
                }
            });
        }

        function addGraphNode(fieldDetails) {
            var graphObject = null;
            var graphObjectLink = null;
            var fillColour = null;

            var xPosition = (fieldDetails.x * drvCtrl.gridWidth) + 1;
            var yPosition = (fieldDetails.y * drvCtrl.gridHeight) + 1;

            var wraptext = joint.util.breakText(fieldDetails.Name, {
                width: drvCtrl.elementWidth,
                height: drvCtrl.elementHeight
            });

            if (!angular.isUndefined(fieldDetails.Scalar) && fieldDetails.Scalar === false) {
                if (!angular.isUndefined(fieldDetails.Cardinality) && fieldDetails.Cardinality === 'One') {
                    if (!angular.isUndefined(fieldDetails.Selected) && fieldDetails.Selected === true) {
                        fillColour = drvCtrl.groupSingleHighlightedColour;
                    }
                    else {
                        fillColour = drvCtrl.groupSingleColour;
                    }
                }
                else {
                    if (!angular.isUndefined(fieldDetails.Selected) && fieldDetails.Selected === true) {
                        fillColour = drvCtrl.groupManyHighlightedColour;
                    }
                    else {
                        fillColour = drvCtrl.groupManyColour;
                    }
                }


                graphObject = new joint.shapes.basic.Rect({
                    position: { x: xPosition, y: yPosition },
                    size: { width: drvCtrl.elementWidth, height: drvCtrl.elementHeight },
                    attrs: { rect: { fill: fillColour }, text: { text: wraptext, fill: 'black' } }
                });
            }
            else {
                if (!angular.isUndefined(fieldDetails.Highlighted) && fieldDetails.Highlighted === true) {
                    fillColour = drvCtrl.elementHighlightedColour;
                }
                else {
                    fillColour = drvCtrl.elementColour;
                }

                graphObject = new joint.shapes.basic.Rect({
                    position: { x: xPosition, y: yPosition },
                    size: { width: drvCtrl.elementWidth, height: drvCtrl.elementHeight },
                    attrs: { rect: { fill: fillColour }, text: { text: wraptext, fill: 'black' } }
                });
            }

            if (!angular.isUndefined(fieldDetails.Parent) && fieldDetails.Parent !== '') {
                var parentField = _.find(drvCtrl.graphMatrix, function (n) {
                    return n.Path === fieldDetails.Parent;
                });

                if (parentField !== null && !angular.isUndefined(parentField.Id)) {
                    graphObjectLink = new joint.dia.Link({
                        source: { id: parentField.Id },
                        target: { id: graphObject.id }
                    });
                }
            }

            fieldDetails.Id = graphObject.id;

            drvCtrl.graphModel.addCells([graphObject]);

            if (!angular.isUndefined(graphObjectLink) && graphObjectLink !== null) {
                drvCtrl.graphModel.addCells([graphObjectLink]);
            }
        }

        /**
         * @returns {bool} true if the jointJS graph element is visible.
         * Note that graph refresh doesn't work if the element isn't visible, because it can't calculate layout.
         */
        function getVisible() {
            return $('#entityFieldsDiagram')[0].offsetParent !== null;
        }

        var lastRefreshWasNotVisible = true;
        function refreshGraph() {
            var visible = getVisible();

            if (visible) {
                drvCtrl.singleSelectCurrentPath = '';
                drvCtrl.generateMatrix();
                drvCtrl.reloadGraph();
            }

            lastRefreshWasNotVisible = !visible;
        }

        function reloadGraph() {
            drvCtrl.graphModel.clear();
            angular.forEach(drvCtrl.graphMatrix, function (field) {
                drvCtrl.addGraphNode(field);
            });

            drvCtrl.diagram.fitToContent({ padding: 10 });
        }

        function fieldClicked(fieldElement) {
            var field = _.find(drvCtrl.graphMatrix, function (n) {
                return n.Id === fieldElement.id;
            });

            if (field.Scalar === true) {
                if (field.Highlighted === true) {
                    drvCtrl.dehighlightField(field);
                }
                else {
                    drvCtrl.highlightField(field);
                }

                if (drvCtrl.multiSelected) {
                    drvCtrl.updateCurrentFields();
                }
            }
            else {
                drvCtrl.changePath(fieldElement);
            }
        }

        function findParent(fieldElement) {
            var result = null;

            var parentNode = drvCtrl.graphModel.getNeighbors(fieldElement, { inbound: true });

            if (!angular.isUndefined(parentNode[0]) && parentNode[0] !== null) {
                var field = _.find(drvCtrl.graphMatrix, function (n) {
                    return n.Id === parentNode[0].id;
                });

                if (field !== null) {
                    if (field.Scalar === false) {
                        result = field;
                    }
                    else {
                        result = drvCtrl.findParent(parentNode[0]);
                    }
                }
            }

            return result;
        }

        // Changes where the path is shown to.
        function changePath(fieldElement) {
            var field = _.find(drvCtrl.graphMatrix, function (n) {
                return n.Id === fieldElement.id;
            });

            var baseField = _.find(drvCtrl.fields, function (n) {
                return n.Path === field.Path;
            });

            // Check to see if the field is currently selected. If it is the graph is being collapsed otherwise it would be expanded.
            if (!angular.isUndefined(baseField.Selected) && baseField.Selected === true) {
                baseField.Selected = false;

                drvCtrl.unselectChild(baseField);
            }
            else {
                baseField.Selected = true;

                drvCtrl.selectParent(baseField);
            }

            drvCtrl.generateMatrix();
            drvCtrl.reloadGraph();
        }

        function selectParent(field) {
            var parentField = _.find(drvCtrl.fields, function (n) {
                return n.Path === field.Parent;
            });

            if (!angular.isUndefined(parentField) && parentField !== null) {
                if (parentField.Scalar === false) {
                    parentField.Selected = true;
                }

                if (!angular.isUndefined(parentField.Parent) && parentField.Parent !== null) {
                    drvCtrl.selectParent(parentField);
                }
            }
        }

        function unselectParent(field) {
            var parentField = _.find(drvCtrl.fields, function (n) {
                return n.Path === field.Parent;
            });

            if (!angular.isUndefined(parentField) && parentField !== null) {
                if (parentField.Scalar === false) {
                    parentField.Selected = false;
                }

                if (!angular.isUndefined(parentField.Parent) && parentField.Parent !== null) {
                    drvCtrl.unselectParent(parentField);
                }
            }
        }

        function selectChild(field) {
            var childFields = _.filter(drvCtrl.fields, function (n) {
                return n.Parent === field.Path;
            });

            angular.forEach(childFields, function (childField) {
                if (!angular.isUndefined(childField) && childField !== null) {
                    if (childField.Scalar === false) {
                        childField.Selected = true;
                    }

                    drvCtrl.selectChild(childField);
                }
            });
        }

        function unselectChild(field) {
            var childFields = _.filter(drvCtrl.fields, function (n) {
                return n.Parent === field.Path;
            });

            angular.forEach(childFields, function (childField) {
                if (!angular.isUndefined(childField) && childField !== null) {
                    if (childField.Scalar === false) {
                        childField.Selected = false;
                    }

                    drvCtrl.unselectChild(childField);
                }
            });
        }

        function dehighlightAll() {
            var fields = _.filter(drvCtrl.graphMatrix, function (n) {
                return n.Scalar === true;
            });

            angular.forEach(fields, function (field) {
                drvCtrl.dehighlightField(field);
            });

            angular.forEach(drvCtrl.fields, function (field) {
                if (field.Scalar && field.Included) {
                    field.Included = false;
                }
            });
        }

        function selectAll() {
            angular.forEach(drvCtrl.fields, function (field) {
                if (field.Scalar === false) {
                    field.Selected = true;
                }
            });
        }

        function unselectAll() {
            angular.forEach(drvCtrl.fields, function (field) {
                if (field.Scalar === false) {
                    field.Selected = false;
                }
            });
        }

        // Used when not in multi select mode, to determine if the field should be shown.
        function showField(field) {
            var result = false;

            // Scalars should only be shown if they have a Display value of true.
            if (field.Scalar) {
                //if (field.Display) {
                result = true;
                //}
            }
                // Non-Scalar types with a cardinality of One do not need to be on the group Path, meanwhile those of cardinality of Many must be on the group Path.
            else if ((!angular.isUndefined(field.Cardinality) && field.Cardinality === 'One') || drvCtrl.singleSelectCurrentPath.startsWith(field.Path)) {
                result = true;
            }

            return result;
        }

        function generateMatrix() {
            drvCtrl.graphMatrix = [];
            var x = 0;

            var rootFields = _.filter(drvCtrl.fields, function (field) {
                return (angular.isUndefined(field.Parent) || field.Parent === null || field.Parent === '');
            });

            // When in multi select mode all fields should be displayed, however when in single select mode we only want to show the fields which exist in data.Fields
            if (drvCtrl.multiSelected) {
                angular.forEach(rootFields, function (field) {
                    var y = drvCtrl.calculateNextRowPosition();
                    drvCtrl.addMatrixField(field, x, y);

                    if (field.Scalar === false && !angular.isUndefined(field.Selected) && field.Selected === true) {
                        drvCtrl.generateMatrixChild(field, x + 1, y);
                    }
                });
            }
            else {
                angular.forEach(rootFields, function (field) {
                    var y = drvCtrl.calculateNextRowPosition();
                    drvCtrl.addMatrixField(field, x, y);

                    if (field.Scalar === false && !angular.isUndefined(field.Selected) && field.Selected === true) {
                        drvCtrl.generateMatrixChild(field, x + 1, y);
                    }
                });
            }

        }

        function generateMatrixChild(parentField, x, y) {
            var childFields = [];

            if (drvCtrl.multiSelected) {
                childFields = _.filter(drvCtrl.fields, function (field) {
                    return (!angular.isUndefined(field.Parent) && field.Parent !== null && field.Parent === parentField.Path);
                });
            }
            else {
                childFields = _.filter(drvCtrl.fields, function (field) {
                    return (!angular.isUndefined(field.Parent) && field.Parent !== null && field.Parent === parentField.Path);
                });
            }

            angular.forEach(childFields, function (field) {
                drvCtrl.addMatrixField(field, x, y);

                if (field.Scalar === false && !angular.isUndefined(field.Selected) && field.Selected === true) {
                    drvCtrl.generateMatrixChild(field, x + 1, y);
                }

                y = drvCtrl.calculateNextRowPosition();
            });
        }

        function addMatrixField(field, x, y) {
            var matrixField = {};
            matrixField.x = x;
            matrixField.y = y;
            matrixField.Name = field.Name;
            matrixField.Path = field.Path;
            matrixField.Scalar = field.Scalar;

            if (!angular.isUndefined(field.Parent) && field.Parent !== null) {
                matrixField.Parent = field.Parent;
            }

            if (field.Scalar === true) {
                matrixField.Highlighted = field.Included;
            }
            else {
                matrixField.Cardinality = field.Cardinality;

                if (!angular.isUndefined(field.Selected) && field.Selected === true) {
                    matrixField.Selected = true;
                }
                else {
                    matrixField.Selected = false;
                }
            }

            drvCtrl.graphMatrix.push(matrixField);
        }

        function calculateNextRowPosition() {
            var result = null;

            if (drvCtrl.graphMatrix.length > 0) {
                var field = _.max(drvCtrl.graphMatrix, function (field) {
                    return field.y;
                });

                if (angular.isUndefined(field) || field === null) {
                    result = 1;
                }
                else {
                    result = field.y + 1;
                }
            }
            else {
                result = 1;
            }

            return result;
        }

        function highlightField(field) {
            var validField = false;

            var fieldElement = drvCtrl.graphModel.getCell(field.Id);

            var parentField = drvCtrl.findParent(fieldElement);

            // If the parent field has cardinality of One, find the next parent field which does not have a cardinality of one
            if (!angular.isUndefined(parentField) && parentField !== null && parentField.Cardinality === 'One') {
                var repeat = true;

                do {
                    var parentFieldElement = drvCtrl.graphModel.getCell(parentField.Id);

                    parentField = drvCtrl.findParent(parentFieldElement);

                    if (angular.isUndefined(parentField) || parentField === null || (!angular.isUndefined(parentField.Cardinality) && parentField.Cardinality === 'Many')) {
                        repeat = false;
                    }
                } while (repeat);
            }

            if (!angular.isUndefined(parentField) && parentField !== null && drvCtrl.fields.Path.startsWith(parentField.Path)) {
                validField = true;
            } else if (angular.isUndefined(field.Parent) || field.Parent === null || field.Parent === '' || angular.isUndefined(parentField) || parentField === null) {
                validField = true;
            } else if (drvCtrl.fields.Path === '' || (!angular.isUndefined(parentField) && parentField !== null && parentField.Path.startsWith(drvCtrl.fields.Path))) {
                if (drvCtrl.multiSelected) {
                    drvCtrl.fields.Path = angular.copy(parentField.Path);
                }
                validField = true;
            }

            if (validField) {
                if (!drvCtrl.multiSelected) {
                    drvCtrl.dehighlightAll();
                    // Get it digested in the parent scope.
                    $scope.$apply(function (n) {
                        drvCtrl.fields.Field = field.Path;
                        drvCtrl.currentMergeField = SystemService.getMergeFieldPrefix() + field.Path + SystemService.getMergeFieldSuffix();
                    });
                }

                var baseField = _.find(drvCtrl.fields, function (n) {
                    return field.Path === n.Path;
                });

                baseField.Included = true;
                field.Highlighted = true;

                fieldElement.attr({ rect: { fill: drvCtrl.elementHighlightedColour } });
            }
        }

        function dehighlightField(field) {
            if (!drvCtrl.multiSelected) {
                // Get it digested in the parent scope
                $scope.$apply(function (n) {
                    drvCtrl.fields.Field = null;
                    drvCtrl.currentMergeField = null;
                });
            }

            var baseField = _.find(drvCtrl.fields, function (n) {
                return field.Path === n.Path;
            });

            baseField.Included = false;
            field.Highlighted = false;

            if (drvCtrl.multiSelected) {
                var newPath = drvCtrl.calculatePath(baseField);

                if (newPath !== null) {
                    drvCtrl.fields.Path = newPath;
                }
            }

            var fieldElement = drvCtrl.graphModel.getCell(field.Id);
            fieldElement.attr({ rect: { fill: drvCtrl.elementColour } });
        }

        function calculatePath(field) {
            var result = '';

            // Check to see if the fields parent is the current path. If they match then the current path will have to check if there are any other fields at this level, otherwise the current path will have to be updated
            if (!angular.isUndefined(field.Parent) && field.Parent !== '' && field.Parent === drvCtrl.data.Path) {
                var includedFields = _.filter(drvCtrl.fields, function (field) {
                    return (!angular.isUndefined(field.Included) && field.Included === true);
                });

                var loopParents = true;
                var parent = angular.copy(field.Parent);

                do {
                    // If the parent field exists and it's cardinality of one, its parent should be should and used.
                    var parentField = _.find(drvCtrl.fields, { 'Path': parent });

                    if (!angular.isUndefined(parentField) && parentField !== null && parentField.Cardinality === 'One') {
                        if (!angular.isUndefined(parentField.Parent) && parentField.Parent !== null) {
                            parent = parentField.Parent;
                        }
                        else {
                            parent = '';
                        }
                    }
                    else {
                        // If there are no other fields
                        if (angular.isUndefined(_.find(includedFields, { 'Parent': parent }))) {
                            var nextParentField = _.find(drvCtrl.fields, { 'Path': parent });

                            if (!angular.isUndefined(parentField) && parentField !== null && !angular.isUndefined(parentField.Parent)) {
                                parent = nextParentField.Parent;
                            }
                            else {
                                loopParents = false;
                            }
                        }
                        else if (parent === null || parent === '') {
                            loopParents = false;
                        } else {
                            result = parent;
                            loopParents = false;
                        }
                    }
                } while (loopParents === true);
            }
            else {
                result = null;
            }

            return result;
        }

        // Used while in multi-select mode. Will update the currentField variable with the currently selected fields.
        function updateCurrentFields() {
            var fieldList = [];

            var includedFields = _.filter(drvCtrl.fields, function (field) {
                return (!angular.isUndefined(field.Included) && field.Included === true);
            });

            angular.forEach(includedFields, function (field) {
                var fieldPath = angular.copy(field.Path);
                fieldList.push(fieldPath);
            });

            $scope.$apply(function (n) {
                drvCtrl.fields.Fields.length = 0;
                drvCtrl.fields.Fields = drvCtrl.data.Fields.concat(fieldList);
            });
        }

        // Click event for elements
        drvCtrl.diagram.on('cell:pointerclick', function (cell, event, x, y) {
            if (!cell.model.isLink()) {
                drvCtrl.fieldClicked(cell.model);
            }
        });
    }
})();